import $ from 'jquery';

import BasePropertyView from 'BasePropertyView.js'
import contentTemplate from 'properties/style/table-header-background.ejs';
import contentTemplate2 from 'properties/style/table-header-background2.ejs';
import { pickerCfg } from 'pickerCfg.js';
import Immutable from 'immutable';
import undoService from 'UndoService';
import themeService from 'ThemeService';
import util from 'util/Util.js';
import textConstants from "../../../constants/TextConstants";
import mobileSyncService from "../../../service/mobile/MobileSyncService";

class StyleTableHeaderBackgroundView extends BasePropertyView {

    initialize(opts) {
        super.initialize();

        this.options = opts || {};

        const noGradient = Immutable.Set(['control_crosstab', 'control_data_list', 'control_data_grid']);

        this.template = contentTemplate;
        if (noGradient.contains(this.model.get('factoryKey'))) {
            this.template = contentTemplate2;
        }
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'blur input[type=text]': 'lostFocus',
            'focus input[type=text]': 'getFocus',
            'change input[type=text]': 'updateColorAttributesWithValidation',
            'change input[type=color]': 'updateColorAttributes'
        };

        return this;
    }

    updateColorAttributes(ev){
        ev.preventDefault();
        const propName = ev.currentTarget.id.replace('Picker', '');
        const propVal = ev.currentTarget.value;
        let oldValue = this.model.get(propName);

        let color = this.resolveColor(propVal);
        // Update model
        this.model.set(propName, color);
        if ( this.isThemeProperty(oldValue) ){
            themeService.deattachTheme(this);
        }

        // Update text input
        $('#' + propName).val(color);
        mobileSyncService.synchronize(this.model, {key: propName, val: propVal });

        // PF-3465 Undo/Redo for Header Color Picker.
        undoService.add({
            undo: () =>{
                // Update model
                this.model.set(propName, oldValue);

                let oldColor = this.resolveColor(oldValue);
                // Update text input
                $('#' + propName).val(oldColor);

            },
            redo:() => {
                // Update model
                this.model.set(propName, color);

                let newColor = this.resolveColor(propVal);

                // Update text input
                $('#' + propName).val(newColor);
            }
        },textConstants.UNDO_COLOR_HEADER_BACKGROUND)
    }

    updateColorAttributesWithValidation(ev){
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;
        let oldValue = this.model.get(propName);

        // PF-3465 Undo/Redo for Header Color Input.
        undoService.add({
            undo: () =>{
                if (util.isValidColorcode(oldValue)) {
                    let color = this.resolveColor(oldValue);
                    this.model.set(propName, color);
                }
                this.render();

            },
            redo:() => {
                if (util.isValidColorcode(propVal)) {
                    let color = this.resolveColor(propVal);
                    this.model.set(propName, color);
                }
                this.render();
            }
        },textConstants.UNDO_COLOR_HEADER_BACKGROUND);


        if (util.isValidColorcode(propVal)) {
            let color = this.resolveColor(propVal);
            this.model.set(propName, color);
            if ( this.isThemeProperty(oldValue) ){
                themeService.deattachTheme(this);
            }
            return true;
        }

        // Call render if invalid color
        this.render();
        return false;
    }


    render() {
        super.render();

        let props = this.resolveThemeColors(this.model, ['headerBgColor', 'headerBgColorGradient']);

        this.$el.html(this.template(props));

        this.delegateEvents();

        return this;
    }

}

export default StyleTableHeaderBackgroundView;
